module.exports = __webpack_public_path__ + "static/media/back-side-rg.c452533b.svg";